import { ProjectSelectorPlusMenuItem } from '#pplx/frontend/composer-sdk-plugins/project-selector/ProjectSelectorPlusMenuItem.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
import { createElement } from 'react';
export function createProjectSelectorPluginFactory() {
    return createPluginFactory({
        name: 'controlled-project-selector',
        capabilities: [
            {
                kind: 'mention',
                configure: () => ({ renderIcon: () => undefined }),
            },
            {
                kind: 'plusMenu',
                onOpenChange: (open, props) => props.onOpenChange?.(open),
                items: async () => [
                    {
                        id: 'projects',
                        render: (context) => createElement(ProjectSelectorPlusMenuItem, context),
                    },
                ],
            },
        ],
    });
}
//# sourceMappingURL=index.js.map